import { createContext } from "react";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../../utils/helpers/constants";
import { IZoneTypeQuery } from "../../../models/wms/zone-type/query";
import {
  IZoneType,
  IZoneTypeDetails,
} from "../../../models/wms/zone-type/response";
import {
  ICreateZoneType,
  IUpdateZoneType,
} from "../../../models/wms/zone-type/request";

export type ZoneTypeLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: ZoneTypeLoading[];
  list?: IBaseListingResponse<IZoneType>;
  query: IZoneTypeQuery;
  details?: IZoneTypeDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IZoneTypeDetails) => void;
    createZoneType: (request: ICreateZoneType) => void;
    updateZoneType: (id: number, request: IUpdateZoneType) => void;
    deleteZoneType: (id: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IZoneTypeQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createZoneType: DEFAULT_FUNCTION,
    updateZoneType: DEFAULT_FUNCTION,
    deleteZoneType: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const ZoneTypeContext = createContext(externalState);
export default ZoneTypeContext;
